import React from 'react'
import PropTypes from 'prop-types'
import MathSpan from '../MathSpan'
import { sanitizeHtml } from '../../utils/html'
import {
  Code,
  CodeCell,
  ExpressionCell,
  SectionContainer,
  SectionTitle,
  Table,
  TableBody,
  TableHeader,
  TableHeaderCell,
  TableRow,
} from './styled'

const RenderTable = ({ latexArray, title, useBackTicks = false }) => (
  <SectionContainer>
    {title && <SectionTitle>{title}</SectionTitle>}
    <Table>
      <TableHeader>
        <TableRow>
          <TableHeaderCell>Expression</TableHeaderCell>
          <TableHeaderCell>LaTeX Code</TableHeaderCell>
        </TableRow>
      </TableHeader>
      <TableBody>
        {latexArray.map((latex, index) => (
          <TableRow key={index}>
            <ExpressionCell>
              <MathSpan
                dangerouslySetInnerHTML={{
                  __html: sanitizeHtml(
                    `<span class="input__math" data-latex="${latex}"></span>`
                  ),
                }}
              />
            </ExpressionCell>
            <CodeCell>
              <Code>{useBackTicks ? `\`${latex}\`` : latex}</Code>
            </CodeCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </SectionContainer>
)

RenderTable.defaultProps = {
  useBackTicks: false,
}

RenderTable.propTypes = {
  latexArray: PropTypes.arrayOf(PropTypes.string).isRequired,
  title: PropTypes.string.isRequired,
  useBackTicks: PropTypes.bool,
}

export default RenderTable
